import { LikeList } from 'javascripts/like_list';
import { CustomLikeList } from 'javascripts/custom_like_list';
import { Timeline } from 'javascripts/timeline';
import { ViewMore } from 'javascripts/view_more';
import Attachment from '../../../javascripts/attachment';
import CommentForm from '../../../javascripts/comment_form';
import ImageZoomer from '../../../javascripts/components/ImageZoomer';
import Like from '../../../javascripts/components/Like';
import ReportReasonModal from '../../../javascripts/report_reason_modal';
import InfiniteScroll from '../../../javascripts/components/infinite_scroll';
import Confirm from '../../../javascripts/components/Confirm';
import ReplyOmitted from '../../../javascripts/components/reply_omitted';
import ReplyCollapse from '../../../javascripts/components/reply_collapse';
import Mute from '../../../javascripts/components/Mute';

if (!window?.Coorum) {
  window.Coorum = {};
}
window.Coorum.Like = Like;
window.Coorum.ImageZoomer = ImageZoomer;
window.Coorum.CommentForm = CommentForm;
window.Coorum.Attachment = Attachment;
window.Coorum.Mute = Mute;

const mute = new Coorum.Mute();

$(() => {
  new ReplyOmitted('.js-reply-omitted');
  new ReplyCollapse('.js-reply-collapse');
  const commentRootElement = document.querySelector('.comments-content');
  const comments = document.querySelectorAll('.p-answer');

  comments.forEach((comment) => {
    mute.setMuteActions({ dataType: 'User', rootElement: comment } );
    mute.setMuteActions({ dataType: 'Question', rootElement: comment });
    mute.addToggleMuteEvent({ rootElement: comment });
  });

  // 初回読み込みイベント
  addActionEvent(document);
  new Timeline(timelineData.question_viewed_url);
  new ViewMore('#view_more', '.loading-image');
  new LikeList('.c-like-list--other');
  new CustomLikeList('.c-custom-like-list--other');
  new Coorum.Like('.js-like');
  new Coorum.Favorite('.js-favorite', {
    button: { toggleMethod: ['post', 'delete'] },
  });
  new Coorum.ImageZoomer().setGeneralEvent();
  new Coorum.CommentForm('.js-comment-form');
  document.querySelectorAll('[id^="report-reason-modal-"]').forEach((modal) => {
    new ReportReasonModal(modal.id);
  });
  document.querySelectorAll('.js-attachment').forEach(
    (elem) => new Coorum.Attachment({ spacing: 12 }, elem, true)
  );
  new InfiniteScroll('.comments-container', '.p-answer', '.js-paginate a');

  // 検知イベント
  const replyWrappers = document.querySelectorAll('.sent-replies');
  const replyMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node) => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          new ReplyOmitted('.js-reply-omitted', node);
        });
    });
  });
  replyWrappers.forEach((replyWrapper) => {
    replyMutation.observe(replyWrapper, { childList: true });
  });

  const docmentMutation = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      Array.from(mutation.addedNodes)
        .filter((node) => node.nodeType === Node.ELEMENT_NODE)
        .forEach((node) => {
          mute.setMuteActions({ dataType: "User", rootElement: node });
          mute.setMuteActions({ dataType: "Question", rootElement: node });
        });
    });
  });
  docmentMutation.observe(document.body, { childList: true });

  if (commentRootElement) {
    const commentRootMutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes)
          .filter((node) => node.nodeType === Node.ELEMENT_NODE)
          .forEach((node) => {
            new LikeList('.c-like-list--other', node);
            new CustomLikeList('.c-custom-like-list--other', node);
            new Coorum.Like('.js-like', false, node);
            new Coorum.ImageZoomer().setGeneralEvent(node);
            if (node.dataset.newComment === 'false') {
              Confirm.setEvents(node);
            }
            const attachment = node.querySelector('.js-attachment');
            if (attachment) {
              new Coorum.Attachment({ spacing: 12 }, attachment, true);
            }
            mute.addToggleMuteEvent({ rootElement: node });
            addActionEvent(node);

            node.querySelectorAll('[id^="report-reason-modal-"]').forEach((modal) => {
              new ReportReasonModal(modal.id);
            });
            new ReplyOmitted('.js-reply-omitted', node);
            new ReplyCollapse('.js-reply-collapse', node);

            node.querySelectorAll('.sent-replies').forEach((replyWrapper) => {
              replyMutation.observe(replyWrapper, { childList: true });
            });
          });
      });
    });
    commentRootMutation.observe(commentRootElement, { childList: true });
  }
});

// 三点リーダーのボタンをクリックした時に表示を切り替えるイベントを登録する
function addActionEvent(rootElement = document) {
  rootElement.querySelectorAll('.js-action_btn').forEach((button) => {
    button.addEventListener('click', () => {
      button.querySelector('.js-action_body').classList.toggle('block');
    });
  });
}
